import { DefaultValues } from 'react-hook-form';
import ProcessCreationFormType from '../interfaces/process-creation.interface';

export const PROCESS_NAME_FORMAT = new RegExp('^[A-Za-zÀ-ÖØ-öø-ÿ0-9-_.\\s/çÇñÑ]+$');
export const TOPIC_PUSH_FORMAT = new RegExp('^[A-Za-z0-9_]+$');
export const PROCESS_NUMBER_FORMAT = new RegExp('^[0-9]+$');

export const DEFAULT_PROCESS_CREATION_DATA: DefaultValues<ProcessCreationFormType> = {
	cliente_genera_numeracion: false,
	referencia_detalle_unica: false,
	combos_asociados: [],
	cotizador: false,
	liquidacion_en_despacho: false,
	liquidacion_en_guia: false,
	nombre_proceso: '',
	// notificacion_destinatario: false,
	prefijo_consecutivo: '',
	servicios_asociados: [],
	topic_push: '',
};

// Rules
export const PREFIX_RULES = {
	required: 'El campo debe tener mínimo 4 dígitos',
	minLength: {
		value: 4,
		message: 'El campo debe tener mínimo 4 dígitos',
	},
};

export const INITIAL_CONSECUTIVE_RULES = {
	required: 'El número inicial debe ser mayor o igual a cero y menor o igual a 9.999.999',
	min: {
		value: 0,
		message: 'El número inicial debe ser mayor o igual a cero y menor o igual a 9.999.999',
	},
	max: {
		value: 9999999,
		message: 'El número inicial debe ser mayor o igual a cero y menor o igual a 9.999.999',
	},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function generateFinalConsecutiveRules(consecutivoDesde = 0): any {
	return {
		required:
			'El campo final debe ser mayor o igual a cero y menor o igual a 9.999.999, y no puede ser menor o igual al inicial',
		min: {
			value: Number(consecutivoDesde) + 1,
			message: 'El campo final debe ser mayor al campo inicial',
		},
		max: {
			value: 9999999,
			message:
				'El campo final debe ser mayor o igual a cero y menor o igual a 9.999.999, y no puede ser menor o igual al inicial',
		},
	};
}

export function generateActualConsecutiveRules(
	clienteGeneraNumeracion: boolean,
	consecutivoDesde = 0,
	consecutivoHasta = 1
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
	return {
		required: {
			value: !clienteGeneraNumeracion,
			message:
				'El campo actual debe ser mayor o igual al campo inicial y menor o igual al campo final',
		},
		min: {
			value: consecutivoDesde,
			message: 'El campo actual debe ser mayor o igual al campo inicial',
		},
		max: {
			value: consecutivoHasta,
			message: 'El campo actual debe ser menor o igual al campo final.',
		},
	};
}
